import React from 'react';
import { Form, Input, Button, InputNumber } from 'antd';
import { WCContainer } from '../../types/wordpress';

interface ContainerFormProps {
    initialValues: WCContainer | null;
    onSubmit: (values: Partial<WCContainer>) => void;
    onCancel: () => void;
}

const ContainerForm: React.FC<ContainerFormProps> = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={{
                ...initialValues,
                title: initialValues?.title?.rendered || initialValues?.title || '',
            }}
            onFinish={(values) => {
                onSubmit({
                    ...values,
                    title: { rendered: values.title },
                });
            }}
        >
            <Form.Item
                label="Name"
                name="title"
                rules={[{ required: true, message: 'Please enter container name' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item label="Common Sizes" name="common_sizes">
                <Input />
            </Form.Item>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <h4 className="font-medium mb-2">External Dimensions</h4>
                    <Form.Item label="Length" name="external_dimensions_length">
                        <InputNumber className="w-full" />
                    </Form.Item>
                    <Form.Item label="Width" name="external_dimensions_width">
                        <InputNumber className="w-full" />
                    </Form.Item>
                    <Form.Item label="Height" name="external_dimensions_height">
                        <InputNumber className="w-full" />
                    </Form.Item>
                </div>

                <div>
                    <h4 className="font-medium mb-2">Internal Dimensions</h4>
                    <Form.Item label="Length" name="internal_dimensions_length">
                        <InputNumber className="w-full" />
                    </Form.Item>
                    <Form.Item label="Width" name="internal_dimensions_width">
                        <InputNumber className="w-full" />
                    </Form.Item>
                    <Form.Item label="Height" name="internal_dimensions_height">
                        <InputNumber className="w-full" />
                    </Form.Item>
                </div>
            </div>

            <div className="flex justify-end gap-2 mt-4">
                <Button onClick={onCancel}>Cancel</Button>
                <Button type="primary" htmlType="submit">
                    {initialValues ? 'Update' : 'Create'}
                </Button>
            </div>
        </Form>
    );
};

export default ContainerForm; 